<template>
  <div>

    <Head />
    <div class="layout">
      <div class="aboutUs">
        <!-- 头部 -->
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p>持之以恒 &nbsp; 事在人为</p>
            </div>
            <div class="right">
              <img
                src="../../assets/images/pc/aboutUs/part1.png"
                alt
              />
            </div>

          </div>
        </div>
        <!-- 公司简介 -->
        <div class="part-2">
          <div class="main">
            <p class="tit">{{$t('aboutUs.part2.tit')}}</p>
            <p class="text1 text">江苏恒为信息科技有限公司(以下称为“恒为信息科技”) 是全国区块链和分布式记账技术标准化技术委员会(SAC/TC590)委员单位、江苏省区块链标准化技术委员会(JS-TC63)委员单位，中国区块链技术和产业发展论坛理事单位、可信区块链推进计划会员单位、江苏省区块链发展协会副理事长单位、无锡市区块链产业联盟会长单位。</p>
            <p class="text1 text">恒为信息科技是由海归学子创建的一家专注于区块链底层技术研发及产业应用部署的江苏省高新技术企业，无锡市专精特新企业，公司于2015年成立于无锡高新区。恒为信息科技拥有完全自主知识产权的高性能区块链底层平台“恒为链”，相关区块链发明专利、软著等40多个，国家区块链信息服务备案项目19个、完成华为云服务、国产统信操作系统、国产申威处理器的信创适配。通过ISO、ITSS，知识产权贯标等多项国家认证。恒为信息科技还与大院大所及高校开展战略合作，内容包括区块链底层技研发及服务、区块链技术标准及测评，行业应用生态建设等。</p>
            <p class="text1 text">依托于独立自主研发的“城市链网”区块链底层基础设施建设技术，恒为信息科技在政务数据治理，数据共享；医疗物资管控，医疗数据共享；农产品溯源及金融服务，农村三资监管；国有资产监管、民政慈善捐款，社会救助；工业互联网，车联网；供应链管理，供应链金融；数字经济，金融监管等多个领域成功落地了30余个应用案例，拥有完整技术解决方案和产品。</p>
            <p class="text1 text">恒为信息科技发展至今成果斐然，参与编写了区块链国家标准1项和团体标准7项，牵头起草地方标准2项，参与编写国内首部《中国区块链与物联网融合创新应用蓝皮书》、《区块链应用操作员国家职业技术技能标准》，参与编写《区块链领导干部读本》、《江苏省工业区块链应用发展白皮书》、《无锡市政务区块链创新应用指南》、《江苏省区块链产业发展报告》、《江苏省工业区块链应用发展白皮书》、《无锡数字经济发展报告》等，2024年连续三年入选国家“产业区块链企业50强”，是无锡市区块链产业核心企业。</p>
          </div>
        </div>
        <!-- 恒为信息 -->
        <div class="part-3">
          <div class="main">
            <p class="tit">{{$t('aboutUs.part6.tit')}}</p>
            <p class="text text1">{{$t('aboutUs.part6.text1')}}</p>
            <p class="text">{{$t('aboutUs.part6.text2')}}</p>
          </div>
        </div>
        <!-- 发展历程 -->
        <div class="part-4">
          <div class="main">
            <p class="tit">发展历程</p>
            <div class="year">
              <span
                :class="year == 2015 ? 'blue':''"
                @click="year = 2015"
              >2015</span>
              <span
                :class="year == 2016? 'blue':''"
                @click="year = 2016"
              >2016</span>
              <span
                :class="year == 2017 ? 'blue':''"
                @click="year = 2017"
              >2017</span>
              <span
                :class="year == 2018 ? 'blue':''"
                @click="year = 2018"
              >2018</span>
              <span
                :class="year == 2019 ? 'blue':''"
                @click="year = 2019"
              >2019</span>
              <span
                :class="year == 2020 ? 'blue':''"
                @click="year = 2020"
              >2020</span>
            </div>
            <div
              class="text"
              v-show="year == 2015"
            >
              <p>
                <span class="time">2015</span>
                <span class="str">公司成立</span>
              </p>
            </div>
            <div
              class="text"
              v-show="year == 2016"
            >
              <p>
                <span class="time">2016 </span>
                <span class="str">参加物博会</span>
              </p>
            </div>
            <div
              class="text"
              v-show="year == 2017"
            >
              <p>
                <span class="time"> 2017/05/12</span>
                <span class="str">成立物联网+区块链联合实验室并发布行动计划</span>
              </p>
              <p>
                <span class="time"> 2017/08</span>
                <span class="str">发布《中国区块链与物联网融合创新应用蓝皮书》</span>
              </p>
              <p>
                <span class="time"> 2017/12/22</span>
                <span class="str">通过中国电子标准化研究院区块链系统技术测评</span>
              </p>
              <p>
                <span class="time"> 2017/12</span>
                <span class="str">《中国区块链与物联网融合创新应用蓝皮书》的发布荣获“2017年度无锡市软件和信息服务业（企业）”十大最具影响力事件</span>
              </p>

            </div>
            <div
              class="text"
              v-show="year == 2018"
            >
              <p>
                <span class="time">2018/09/17 </span>
                <span class="str">承办2018世界物联网大会区块链与物联网融合发展峰会</span>
              </p>
            </div>
            <div
              class="text"
              v-show="year == 2019"
            >
              <p>
                <span class="time">2019/04/17 </span>
                <span class="str">启动国内首部物联网与区块链融合地方标准的编制 </span>
              </p>
              <p>
                <span class="time">2019/08  </span>
                <span class="str">成为中国区块链技术和产业发展论坛理事成员 </span>
              </p>
              <p>
                <span class="time">2019/10/18 </span>
                <span class="str">“恒为链”成功通过境内区块链信息服务服务备案</span>
              </p>
            </div>
            <div
              class="text"
              v-show="year == 2020"
            >
              <p>
                <span class="time">2020/04/13</span>
                <span class="str">工信部发布《全国区块链和分布式记账技术标准化技术委员会委员名单》，恒为信息科技成为第一届委员成员  </span>
              </p>
              <p>
                <span class="time">2020/05/18</span>
                <span class="str">成立恒为全资子公司“苏州恒链数科区块链科技有限公司”  </span>
              </p>
              <p>
                <span class="time">2020/06/9</span>
                <span class="str">成立生态分公司“万物汇智信息技术（上海）有限公司”</span>
              </p>
              <p>
                <span class="time">2020/06/23</span>
                <span class="str">成立无锡市区块链产业联盟，恒为信息科技成为首届会长单位</span>
              </p>
            </div>
          </div>
        </div>
        <!-- 公司荣誉 -->
        <div class="part-5">
          <div class="main">
            <p class="tit">{{$t('aboutUs.part3.tit')}}</p>
            <div class="l">
              <img
                src="../../assets/images/pc/aboutUs/part5-1.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-2.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-3.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-4.png"
                alt
              />
            </div>
            <div class="l l2">
              <img
                src="../../assets/images/pc/aboutUs/part5-5.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-6.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-7.png"
                alt
              />
              <img
                src="../../assets/images/pc/aboutUs/part5-8.png"
                alt
              />
            </div>
          </div>
        </div>
        <!-- 联系我们 -->
        <div class="part-6">
          <div class="main">
            <div class="content">
              <div class="left">
                <p class="tit">{{$t('aboutUs.part4.tit')}}</p>
                <div class="text">
                  <div class="tel info">
                    <p class="iconfont icondianhua p1"></p>
                    <p class="p2"> 固定电话：0510-85386599</p>
                  </div>
                  <div class="emails info">
                    <p class="iconfont iconxinfeng p1"></p>
                    <div class="email">
                      <p>{{$t('aboutUs.part4.email1')}}： service@hwelltech.com</p>
                      <p>{{$t('aboutUs.part4.email2')}}： marketing@hwelltech.com</p>
                      <p>{{$t('aboutUs.part4.email3')}}： blockchain@hwelltech.com</p>
                    </div>
                  </div>
                  <div class="add info">
                    <p class="iconfont icondingwei p1"></p>
                    <p class="p2">{{$t('aboutUs.part4.add')}}</p>
                  </div>

                </div>
              </div>
              <div class="img">
                <img
                  src="../../assets/images/pc/aboutUs/part6.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/pc/Head";
import Foot from "../../components/pc/Foot";
export default {
  name: "aboutUs",
  components: {
    Head,
    Foot,
  },
  data() {
    return {
      cn: false,
      en: false,
      y: 19,
      year: 2020,
    };
  },
  mounted() {
    this.mobile();
  },
  created() {
    this.getLang();
  },

  methods: {
    getLang() {
      var lang;
      if (this.$i18n.locale == "en") {
        this.en = true;
        this.lang = "en";
      } else {
        this.cn = true;
        this.lang = "cn";
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  min-width: @min-width;
  background-color: #f8f9fb;
}
.aboutUs {
  background: #fff;
  .part-1 {
    margin-top: 70px;
    height: 511px;
    width: 100%;
    .bg(@url:url("../../assets/images/pc/aboutUs/part1-bg.png"));
    background-size: auto 511px;
    .main {
      padding: 0;
      .left {
        float: left;
        padding-top: 218px;
        padding-left: 40px;
        p {
          font-size: 40px;
          color: #fff;
          line-height: 40px;
        }
      }
      .right {
        width: 50%;
        float: left;

        img {
          width: 919px;
          height: 466px;
          margin: 45px 0 0 178px;

          @media screen and(min-width: 1366px) {
          }
          @media screen and(max-width: 1366px) {
          }
        }
      }
    }
  }
  .part-2 {
    background: #fff;
    padding: 80px 0 70px;

    .main {
      padding: 0;
      .tit {
        .onlyTit();
      }

      .text {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        text-indent: 28px;
      }
      .text1 {
        margin-bottom: 20px;
      }
    }
  }
  .part-3 {
    padding: 80px 0 70px;
    .bg(@url: url("../../assets/images/pc/aboutUs/part3-bg.png"));
    background-size: auto 100%;
    .main {
      padding: 0;
      .tit {
        .onlyTit();
        color: #fff;
      }
      .text {
        font-size: 14px;
        color: #fff;
        line-height: 24px;
        text-indent: 28px;
      }
      .text1 {
        margin-bottom: 20px;
      }
    }
  }
  .part-4 {
    padding: 80px 0;
    background: #f9f9f9;
    .main {
      padding: 0;
      .tit {
        .onlyTit();
      }
      .year {
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        height: 52px;
        span {
          display: inline-block;
          width: 110px;
          margin: 0 40px;
          font-size: 14px;
          line-height: 53px;
          height: 100%;
          color: #2a93ff;
          cursor: pointer;
          text-align: center;
          position: relative;
          &:hover {
            .blue();
          }
        }
        .blue {
          .blue();
        }
      }
      .text {
        margin: 27px auto 0;
        width: 936px;
        // height: 250px;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 55px 167px;
        p {
          display: flex;
          margin-bottom: 10px;
          span {
            display: inline-block;
            font-size: 14px;
            line-height: 24px;
          }
          .time {
            width: 76px;
            margin-right: 18px;
          }
          .str {
            width: 494px;
          }
        }
        p:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
  .part-5 {
    padding: 80px 0 70px;
    background: #ffffff;
    .main {
      padding: 0;
      .tit {
        .onlyTit();
      }
      .l {
        width: 100%;
        display: flex;
        img {
          width: 283px;
         
          margin: 0 4px;
        }
      }
      .l{
        img{
          height: 391px;
        }
      }
      .l2{
        img{
          height: 205px;
        }
      }
    }
  }

  .part-6 {
    height: 522px;
    .bg(@url: url("../../assets/images/pc/aboutUs/part6-bg.png"));
    background-size: auto 522px;

    // @media screen and(max-width: 1366px) {
    // background-image: url("../../assets/images/pc/aboutUs/part4-bg2-new.png");
    // background-size: 100% 100%;
    // }
    .main {
      padding: 0;
      height: 100%;
      padding-top: 89px;
      .content {
        background-color: #fff;

        margin-left: 490px;
        // @media screen and(max-width: 1366px) {
        // margin-left: 53%;
        // }
        padding: 61px 31px 49px 37px;
        width: 521px;
        display: flex;
        .left {
          width: 299px;

          .tit {
            margin-bottom: 31px;
            font-size: 24px;
            color: #444444;
            line-height: 24px;
          }
          .text {
            width: 100%;
            .info {
              width: 100%;
              display: flex;
              .p1 {
                width: 18px;
                margin-right: 10px;
                display: inline-block;
                font-size: 18px;
                position: relative;
                top: -3px;
              }
              .p2 {
                width: 317px;
                font-size: 14px;
                color: #444444;
              }
            }
            .tel {
              margin-bottom: 25px;
            }
            .emails {
              margin-bottom: 25px;
              .email {
                p {
                  font-size: 14px;
                  color: #444444;
                }
              }
            }
            .add {
            }
          }
        }
        .img {
          margin: 45px 0 0 12px;

          img {
            width: 130px;
            height: 130px;
          }
        }
      }
    }
    /deep/.iconfont {
      color: #3a88f7;
    }
  }
}
</style>